import { Component, signal, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable, finalize, map } from 'rxjs';
import { PublicEducatorCertificateDetailDto, PublicPortalClient } from 'src/shared/services/api.service';

@Component({
  standalone: false,
  selector: 'edportal-educator-detail',
  templateUrl: './educator-detail.component.html',
  styles: ``,
})
export class EducatorDetailComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly publicPortalClient: PublicPortalClient,
    private readonly router: Router,
  ) {}
  personId$!: Observable<number>;

  personId!: number;
  educator!: PublicEducatorCertificateDetailDto;
  dataLoaded = signal(false);

  ngOnInit() {
    this.personId$ = this.route.paramMap.pipe(
      map((params: ParamMap) => {
        return parseInt(params.get('personId')!);
      }),
    );

    this.personId$.subscribe((x) => {
      this.getEducatorCertificateDetail(x);
    });
  }

  getEducatorCertificateDetail(personId: number) {
    this.publicPortalClient
      .getEducatorCertificateDetail(personId)
      .pipe(finalize(() => this.dataLoaded.set(true)))
      .subscribe((x) => {
        this.educator = x;
      });
  }

  navigateSearch() {
    this.router.navigate(['public']);
  }
}
